module.exports = __webpack_public_path__ + "static/shullogo-9d5e6a12bf4d5c183e1bcf11a1e1d700.jpg";